import { Form } from 'antd';
import React from 'react';
import { GET, StepForm, user_profile } from 'utils';

import { useQuery } from 'react-query';

import Options from './Options';
import SubmitButton from './SubmitButton';

const Two: React.FC<StepForm> = ({ form_data, onSubmit, onBack }) => {
  const { Item } = Form;
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const workshiftData = useQuery('get-workshift', async () => {
    try {
      const res = await GET('/api/workshift-policy/option/');
      return res.data;
    } catch (error) {
      console.log('error', error);
    }
    return null;
  });
  const staffLeaveData = useQuery('get-staffleave', async () => {
    try {
      return await GET('/api/absence-policy/option/');
    } catch (error) {
      console.log('error', error);
    }
  });

  const workShiftList =
    workshiftData?.data?.length > 0 &&
    workshiftData?.data?.map((item: object) => {
      return {
        label: item['name'],
        value: item['id'],
      };
    });
  const staffLeaveList =
    staffLeaveData?.data?.data?.length > 0 &&
    staffLeaveData?.data?.data.map((item: object) => {
      return {
        label: item['name'],
        value: item['id'],
      };
    });


  return (
    <div>
      <h1
        className="form-wrapper_title"
        style={{ fontSize: '1.5rem', marginBottom: 24 }}
      >
        Requirements
      </h1>

      <Form
        initialValues={form_data}
        form={form}
        onFinish={onSubmit}
        name="validateOnly"
      >
        <div className="is-flex" style={{ gap: 16 }}>
          <div className="form-wrapper">
            <h1 className="form-wrapper_title">Generalities</h1>
            <Options
              name={'role'}
              rule={[{ required: true, message: 'User Profile is required' }]}
              options={user_profile}
              height="50px"
              required
              onChange={(v: Object) => {
                if (form_data?.['department_id']) {
                  form_data['department_id'] = null;
                  form_data['service_id'] = null;
                  form_data['manager_ids'] = null;
                }
                form.setFieldValue('role', v);
              }}
              title="User Profile"
            />
            <div className="mb-4 mt-5">
              <Options
                name="workshifts"
                rule={[{ required: true, message: 'Work Shift is required' }]}
                options={workShiftList ? workShiftList : undefined}
                height="50px"
                required
                title={'Work Shift'}
                onChange={(v: number) => form.setFieldValue('workshifts', [v])}
              />
            </div>
          </div>
          <div className="form-wrapper">
            <h1 className="form-wrapper_title">
              Staff Leave & Absence Management
            </h1>
            <Options
              name="absence_policy_id"
              options={staffLeaveList ? staffLeaveList : undefined}
              onChange={undefined}
              height="50px"
              required
              rule={[
                {
                  required: true,
                  message: 'Staff leave / absence profile is required',
                },
              ]}
              title="Staff leave / absence profile"
            />
          </div>
        </div>
        <div className="is-pulled-right my-4 is-flex">
          <button
            className={
              'add_user_button  is-flex is-justify-content-center is-align-items-center  mr-3'
            }
            onClick={() => onBack(values)}
          >
            <img src="/icons/next_button.svg" alt="next" />
            <span>BACK</span>
          </button>
          <Item>
            <SubmitButton form={form} />
          </Item>
        </div>
      </Form>
    </div>
  );
};

export default Two;
